import { makeErrorDetails } from '../records/ErrorDetails';
export function getRequestId() {
  return Math.floor(Date.now() / Math.random());
}
export function getErrorDetails(error, hostConfig) {
  const defaultConfig = hostConfig.errors.get('default');
  if (!defaultConfig) {
    throw new Error('No default config for error messages specified');
  }
  try {
    if (typeof error === 'string') {
      const err = hostConfig.errors.get(error) || defaultConfig;
      return makeErrorDetails({
        translation: err.set('showTID', false),
        tid: err.tid,
        type: err.type
      });
    } else {
      const translatedError = defaultConfig.set('description', error.errorMessage).set('showTID', false);
      return makeErrorDetails({
        translation: translatedError,
        tid: 'None',
        type: 'None'
      });
    }
  } catch (_unused) {
    return makeErrorDetails({
      translation: defaultConfig.set('showTID', false)
    });
  }
}